import styled from 'styled-components'

export const Title = styled.h2`
  color: ${props => props.theme.colors.color6b7786};
  font-size: 12px;
  line-height: 30px;
`
